import React from 'react'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'

const StyledTr = styled('tr')`
  border-bottom: ${({ hasCorrections }) =>
    hasCorrections ? '0px' : '1px solid #d3d3d3;'};
  background: ${({ isParent }) => (isParent ? '' : '#ECEDEF')};

  &.type td: first - child {
    position: relative;

    :: before {
      content: '';
      width: 4px;
      height: 100%;
      display: block;
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  @media only screen and(min - width: 960px) {
    &.type td: first - child:: before {
      height: 16px;
      top: 50 %;
      margin-top: -8px;
    }
  }
`

const InvoiceRow = ({
  onClick,
  isParent,
  hasCorrections,
  children,
  ...rest
}) => (
  <StyledTr
    onClick={onClick}
    isParent={isParent}
    hasCorrections={hasCorrections}
    {...rest}
  >
    {children}
  </StyledTr>
)

InvoiceRow.propTypes = {
  itemType: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.any.isRequired,
  onClick: PropTypes.func,
  isParent: PropTypes.bool.bool,
  hasCorrections: PropTypes.bool,
}

export default InvoiceRow
